import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import ReturnsStatusTag from 'components/base/returns-status-tag';
import { useNavigate } from 'react-router-dom';
import { ExcessReturnsType } from 'pages/main-store/excess-returns';
import useExcessReturnContext from 'contexts/excess-returns.context/context';
import { formatCurrency, formatRequestDate } from 'utils/functions';

type Props = {
  returns: ExcessReturnsType;
};

const ReturnsCard: FC<Props> = ({ returns }) => {
  const { setExcessReturnToUpdate } = useExcessReturnContext();
  const router = useNavigate();
  const orderCode = returns?.id.substring(0, 5).toLowerCase();

  const viewRequest = () => {
    setExcessReturnToUpdate(returns);
    router(returns.id.toString());
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{orderCode?.toUpperCase()}</h4>
            <ReturnsStatusTag type={returns?.status} />
          </div>

          <div className='p-3 text-sm'>
            {returns?.items?.map((item, i) => (
              <div key={i} className='flex  items-center '>
                <p>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className='text-sm text-gray-5'>
                  {' '}
                  {item.quantity}
                  {item.ingredient.unit_type || 'portions'} (
                  <span>
                    {formatCurrency(
                      Number(item.quantity) * Number(item.ingredient.min_vendor_price)
                    )}
                  </span>
                  )
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {formatRequestDate(returns.created_at)}</p>

          <Button className='text-xs' color='primary' variant='link' onClick={viewRequest}>
            See all
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default ReturnsCard;
